<script setup lang="ts">
  import { computed, ref } from 'vue'
  import { FileCheck, FileQuestion } from 'lucide-vue-next'
  import { AnalysisWizardModel } from '../../models/AnalysisWizardModel'
  import FullScreenModal from '@/components/FullScreenModal.vue'
  import DataViewer from '@/components/DataViewer.vue'

  export interface IDataProcessingStepStatusProps {
    wizardModel: AnalysisWizardModel
  }

  const props = defineProps<IDataProcessingStepStatusProps>()

  const dataViewerModalOpen = ref<boolean>(false)

  const viewFileData = async () => {
    if (props.wizardModel.sharedModel?.cleanedFile != null) {
      dataViewerModalOpen.value = true
    }
  }

  const closeDataViewerModal = () => {
    dataViewerModalOpen.value = false
  }

  const hasCleanedFile = computed(() => props.wizardModel.sharedModel?.cleanedFile != null)
</script>

<template>
  <a-tooltip>
    <template #title>
      {{ hasCleanedFile ? 'Preview Cleaned Data' : 'Select file to preview' }}
    </template>

    <div @click="viewFileData" class="flex" :class="{ 'cursor-pointer': hasCleanedFile }">
      <component
        :is="hasCleanedFile ? FileCheck : FileQuestion"
        class="size-6"
        :style="{
          color: hasCleanedFile ? 'var(--primary, #5aa745)' : 'var(--foreground-80, #9CA3AF)'
        }"
        aria-hidden="true"
      />

      <span class="ml-2 self-center truncate">
        <b>Cleaned dataset:</b>
        <span class="ml-1">
          {{
            hasCleanedFile ? props.wizardModel.sharedModel?.cleanedFile?.name : 'No cleaned data'
          }}
        </span>
      </span>
    </div>
  </a-tooltip>
  <!-- Data Viewer Modal -->
  <FullScreenModal
    :open="dataViewerModalOpen"
    title="Data Viewer"
    :description="props.wizardModel.sharedModel?.inputFile?.name"
    @close="closeDataViewerModal"
  >
    <DataViewer :fileId="props.wizardModel.sharedModel?.cleanedFile?.id || ''" />
  </FullScreenModal>
</template>
